import { Button, Stack } from '@mui/material';
import { useCallback, useState } from 'react';
import { useTranslate } from 'react-admin';
import { CustomBreadcrumbs } from '../../../../../components/custom-breadcrumbs';
import { DashboardContent } from '../../../../../layouts/dashboard';
import { paths } from '../../../../../routes/paths';
import { PermissionGuard } from '../../../../../routes/components/permission-guard';
import ErrorPage403 from '../../../../error/403';
import { SectionLeaderboard } from './SectionLeaderboard';

export default function BlindBoxLeaderboardList() {
  const t = useTranslate();
  const [refreshKey, setRefreshKey] = useState(0);
  const refreshAll = useCallback(() => setRefreshKey((k) => k + 1), []);

  return (
    <PermissionGuard resource="bb-leaderboard" action="read" fallback={<ErrorPage403 />}>
      <DashboardContent maxWidth={false}>
        <CustomBreadcrumbs
          heading={t('module.blindBox.leaderboard')}
          links={[
            { name: t('module.blindBox.title'), href: paths.blindBox.overview.root },
            { name: t('module.blindBox.leaderboard') },
          ]}
          action={
            <Stack direction="row" spacing={1} flexWrap="wrap" useFlexGap>
              <Button size="small" variant="outlined" onClick={refreshAll}>
                {t('module.blindBox.refreshAll')}
              </Button>
            </Stack>
          }
        />
        <SectionLeaderboard refreshKey={refreshKey} />
      </DashboardContent>
    </PermissionGuard>
  );
}
